// api-request.ts on the client will use this variable to identify
// its version using the Capacitor-Updater-Bundle-Version header.
// this module will compare the version in the header to the string
// below to see if a client update is needed.
export const CAPACITOR_UPDATER_BUNDLE_VERSION = '2026-10-07-A';
